import React from 'react'
import { MdEdit } from 'react-icons/md'

const ProfileTab = ({name='',value='',edit,isEdit=false}) => {
  return (  <div className="flex items-center gap-4">
  <div>  
  {/* <p className="text-blue-500">
    {name}
  </p> */}
    <h4 className="text-blue-700 text-lg">{value}</h4> 
  </div>
  {
    isEdit&&
      <MdEdit onClick={edit}/>
  }
  </div>
  )
}

export default ProfileTab